import { QueryClient } from "@tanstack/react-query";
import { createMemoryHistory, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { IS_EXTENSION } from "./lib/runtime";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    // The extension page lives at chrome-extension://<id>/newtab.html, so a
    // browser history would resolve the path "/newtab.html" and never match "/".
    history: IS_EXTENSION ? createMemoryHistory({ initialEntries: ["/"] }) : undefined,
  });

  return router;
};

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
